import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import PayerActivityServiceCodes from './payerActivityServiceCodes';
import { getActivities, UpdatePayerActivityStatus } from '../../actions/index';
import Alert from 'react-s-alert';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField, renderToggleButton } from '../../../../components/reduxFields';
import SortingCustom from '../../../../components/SortingCustom';
import { alertConfirmation, resetFiltersAndSorting, showNormalizedRate } from '../../../../actions/utilAction';
import PaginatorCustom from '../../../../components/paginationCustom';

class PayerActivity extends Component {

  constructor(props) {
    super(props);
    this.state = {
      payerActivityId: null,
      isPayerActivityPage: true,
      activeToggleValues: [],
      noteTypeId: null,
    };

    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };

    this.handleSearchPayerActivity = this.handleSearchPayerActivity.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { payerId: this.props.payerId,
        SearchText: this.filter.searchText },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getActivities(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }
  componentWillMount() {
    this.loadData();
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.deletePayerActivity && this.props.deletePayerActivity !== nextProps.deletePayerActivity) {
      this.loadData();
    }

    

    if (nextProps.payerActivityList && this.props.payerActivityList !== nextProps.payerActivityList) {
      let payerActivityList = nextProps.payerActivityList;     
      let activeToggleValues = new Array(payerActivityList.length).fill({}); 

      let index = 0;
      payerActivityList.map((obj) => {
        if (activeToggleValues.indexOf(obj) === -1) {
          activeToggleValues.splice(index, 1, obj);
          index = index + 1;
        }
        return activeToggleValues;
      });

      this.setState({
        activeToggleValues: activeToggleValues,
      });
    }
  }

  handleActiveAlertClick = (event, index, userID) => {
    let activeToggleValues = this.state.activeToggleValues;
    activeToggleValues[index].isActive = !activeToggleValues[index].isActive;
    this.setState({
      activeToggleValues: activeToggleValues,
    });
    this.props.UpdatePayerActivityStatus(userID, this.state.activeToggleValues[index].isActive, this.props.payerId);
    Alert.closeAll();
  };

  onActiveToggle(e, index, obj) {    
    alertConfirmation((obj.isActive ? 'Are you sure you want to hide this activity for future sessions?' : 'Are you sure you want to continue?'), {  
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleActiveAlertClick,
        // value: e.target.value,
        id: index,
        userID: obj.appointmentTypeID,
      },
    });
  };

  handleReset = () => {
    Alert.closeAll();
    this.setState({ payerActivityId: null, activeToggleValues: [] });
    this.refs.name.setState({ value: '' });
    this.loadData();
  };
  handleClose = () => {
    this.setState({ isPayerActivityPage: true });
    this.setState({ payerActivityId: null });
    this.loadData();
  };
  handleAlertClick = (event, payerActivityId) => {
    // this.props.deletePayerActivity(payerActivityId);
    Alert.closeAll();
  }
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {
    alertConfirmation('Are you sure you want to delete activity for this payer ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.appointmentTypeID,
      },
    });
  }
  handleAddActivity = () => {
    this.setState({ isPayerActivityPage: false, payerActivityId: null });

  }
  handleEditClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ isPayerActivityPage: false, payerActivityId: obj.appointmentTypeID, noteTypeId: obj.noteTypeId });
  }
  handleSearchPayerActivity(event) {
    if (event.name !== undefined) {
    }
  }
  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('PayerActivityForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.loadData();
  }
  renderData() {
    if (!this.props.payerActivityList || !this.props.payerActivityList.length) {
      return (
        <tr>
          <td colSpan="4">
            <div className="familydl text-center no-record">No record found</div>
          </td>
        </tr>
      );
    }
    return this.props.payerActivityList.map((Obj, index) => {
      return (
        <tr key={index}>
          <td>{Obj.name}</td>
          <td>{Obj.value}</td>
          <td>{showNormalizedRate(Obj.ratePerUnit)}</td>
          {/* <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Active' : 'In Active'}</td> */}
          <td>
            <Field className="no_margin"
                name="active_status"
                toggled={this.state.activeToggleValues[index] && this.state.activeToggleValues[index].isActive ? this.state.activeToggleValues[index].isActive : false}
                component={renderToggleButton}               
                onChange={(e) => this.onActiveToggle(e, index, Obj)}
              />
          </td>
          <td>
            <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
            {/* <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button> */}
          </td>
        </tr>
      );
    });
  }
  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        {!this.state.isPayerActivityPage ?
          (<PayerActivityServiceCodes payerId={this.props.payerId} payerActivityId={this.state.payerActivityId} backToActivitiesPage={this.handleClose} noteTypeId={this.state.noteTypeId} />)
          :
          (<div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 custm_checkstyle">
                  <span>Please enter the rate you bill to the payer will in this area. These are the rates you will be charging the payer.</span>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-5">
                <RaisedButton label="Add Activity" primary={true} onTouchTap={this.handleAddActivity} />
              </div>
              <div className="col-sm-7">
                <div className="row end-flex">
                  <div className="col-sm-6 mtm-27">
                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchPayerActivity)}>
                      <Field
                        name="name"
                        floatingLabelText="Search"
                        maxLength='15'
                        onChange={this.handleSearchChange}
                        component={renderTextField}
                      />
                    </form>
                  </div>
                  <div className="reset-btn col-sm-3 btn_rt">
                    <RaisedButton onTouchTap={this.handleResetButton} className="grey_btn">Reset</RaisedButton>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="40%"><SortingCustom setSortColumn={this.setSortColumn} columnName='name' displayName='Activity Name' /></th>
                        <th width="20%">Service Code</th>
                        <th width="15%">Rate($)</th>
                        <th width="15%">Status</th>
                        <th width="10%">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderData()}
                    </tbody>
                  </table>
                  {this.props.metaData && this.props.metaData.totalPages ?
                    <PaginatorCustom data={this.props.metaData} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>)}
      </div>
    );
  }
}

PayerActivity = reduxForm({
  form: 'PayerActivityForm',
})(PayerActivity);

function mapStateToProps(state) {
  let payerActivityList = [], metaData = null;
  if (state.payer.payerActivityData && state.payer.payerActivityData.data) {
    payerActivityList = state.payer.payerActivityData.data;
    metaData = state.payer.payerActivityData.meta;
    // console.log('state', state.payer.payerActivityData.data);
  }
  return {
    payerActivityList: payerActivityList,
    metaData: metaData,
    deletePayerActivity: state.payer.deletePayerActivity,
  };
}
export default connect(mapStateToProps, { getActivities, UpdatePayerActivityStatus })(PayerActivity);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/payerActivities.js